// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:where(.vuetify-styles) .bottom-sheet-transition-enter-from {
  transform: translateY(100%);
}
:where(.vuetify-styles) .bottom-sheet-transition-leave-to {
  transform: translateY(100%);
}

:where(.vuetify-styles) .v-bottom-sheet > .v-bottom-sheet__content.v-overlay__content {
  align-self: flex-end;
  border-radius: 0;
  flex: 0 1 auto;
  left: 0;
  right: 0;
  margin-inline: auto;
  margin-bottom: 0;
  transition-duration: 0.2s;
  width: 100%;
  max-width: 100%;
  overflow: visible;
}
:where(.vuetify-styles) .v-bottom-sheet > .v-bottom-sheet__content.v-overlay__content {
  box-shadow: 0px 7px 8px -4px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 12px 17px 2px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 5px 22px 4px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12));
}
@media (prefers-reduced-motion: reduce) {
  :where(.vuetify-styles) .v-bottom-sheet > .v-bottom-sheet__content.v-overlay__content {
    transition: none;
  }
}
:where(.vuetify-styles) .v-bottom-sheet > .v-bottom-sheet__content.v-overlay__content > .v-card,
:where(.vuetify-styles) .v-bottom-sheet > .v-bottom-sheet__content.v-overlay__content > .v-sheet {
  border-radius: 0;
}
:where(.vuetify-styles) .v-bottom-sheet.v-bottom-sheet--inset {
  max-width: none;
}
@media (min-width: 600px) {
  :where(.vuetify-styles) .v-bottom-sheet.v-bottom-sheet--inset {
    max-width: 70%;
  }
}`, "",{"version":3,"sources":["webpack://./node_modules/vuetify/lib/components/VBottomSheet/VBottomSheet.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,OAAO;EACP,QAAQ;EACR,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,WAAW;EACX,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,0OAA0O;AAC5O;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;;EAEE,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE;IACE,cAAc;EAChB;AACF","sourcesContent":[".bottom-sheet-transition-enter-from {\n  transform: translateY(100%);\n}\n.bottom-sheet-transition-leave-to {\n  transform: translateY(100%);\n}\n\n.v-bottom-sheet > .v-bottom-sheet__content.v-overlay__content {\n  align-self: flex-end;\n  border-radius: 0;\n  flex: 0 1 auto;\n  left: 0;\n  right: 0;\n  margin-inline: auto;\n  margin-bottom: 0;\n  transition-duration: 0.2s;\n  width: 100%;\n  max-width: 100%;\n  overflow: visible;\n}\n.v-bottom-sheet > .v-bottom-sheet__content.v-overlay__content {\n  box-shadow: 0px 7px 8px -4px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 12px 17px 2px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 5px 22px 4px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12));\n}\n@media (prefers-reduced-motion: reduce) {\n  .v-bottom-sheet > .v-bottom-sheet__content.v-overlay__content {\n    transition: none;\n  }\n}\n.v-bottom-sheet > .v-bottom-sheet__content.v-overlay__content > .v-card,\n.v-bottom-sheet > .v-bottom-sheet__content.v-overlay__content > .v-sheet {\n  border-radius: 0;\n}\n.v-bottom-sheet.v-bottom-sheet--inset {\n  max-width: none;\n}\n@media (min-width: 600px) {\n  .v-bottom-sheet.v-bottom-sheet--inset {\n    max-width: 70%;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
